<template>
  <app-layout></app-layout>
</template>

<script>
import AppLayout from "./layout/Index";
export default {
  name: "App",
  components: {
    AppLayout,
  },
  data: () => ({
    //
  }),
};
</script>
<style lang="scss">
@import "./assets/style/global.scss";
</style>
